import { render, staticRenderFns } from "./Collectors.vue?vue&type=template&id=e0feb010&scoped=true&"
import script from "./Collectors.vue?vue&type=script&lang=js&"
export * from "./Collectors.vue?vue&type=script&lang=js&"
import style0 from "./Collectors.vue?vue&type=style&index=0&id=e0feb010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0feb010",
  null
  
)

export default component.exports